import { useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AppContexts } from "../../providers";
import { usePermissionsStore } from "../permissions/permissions_store";
import { CRM_NAV_ITEMS } from "../../config/crm-navigation";

export { CRM_NAV_ITEMS };

export default function CRMSidebar({ activeKey, onNavigate }) {
  const { canView } = usePermissionsStore();
  const { counts = {}, loadSidebarCounts } = useContext(AppContexts.CRMContext) || {};
  const rentals = useContext(AppContexts.RentalsContext);
  const rentalsRef = useRef(rentals);
  rentalsRef.current = rentals;
  const canReadContacts = canView("crm.contacts");
  const canReadProperties = canReadContacts || canView("crm.pipelines");

  useEffect(() => {
    if (canReadContacts) loadSidebarCounts?.();
  }, [canReadContacts, loadSidebarCounts]);

  useEffect(() => {
    if (canReadProperties) rentalsRef.current?.get?.();
  }, [canReadProperties]);

  return (
    <nav className="crm-sidebar" aria-label="CRM">
      <div className="crm-sidebar-header"><h3>CRM</h3></div>
      <div className="crm-sidebar-nav">
        {CRM_NAV_ITEMS.filter((item) => canView(item.module || "crm.contacts")).map((item) => (
          <div key={item.key}>
            <Link
              to={item.path || `/crm/${item.slug}`}
              className={`crm-sidebar-item crm-sidebar-child${activeKey === item.key ? " is-active" : ""}`}
              aria-current={activeKey === item.key ? "page" : undefined}
              onClick={(event) => {
                if (!onNavigate || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                onNavigate(item.key, item.path);
              }}
            >
              <span className="crm-sidebar-item-left">{item.label}</span>
              {!item.path && <span className="crm-sidebar-count">
                {item.key === "unit" ? rentals?.rentals?.length ?? counts.unit ?? 0 : counts[item.key] || 0}
              </span>}
            </Link>
            {item.separator && <div className="crm-sidebar-divider" />}
          </div>
        ))}
      </div>
    </nav>
  );
}
